export default __webpack_public_path__ + "static/media/DigevoVentures.3e8f1fd6.svg";